import { render, staticRenderFns } from "./ModelingRuleInfo.vue?vue&type=template&id=0a44847e&scoped=true&"
import script from "./ModelingRuleInfo.vue?vue&type=script&lang=js&"
export * from "./ModelingRuleInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModelingRuleInfo.vue?vue&type=style&index=0&id=0a44847e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a44847e",
  null
  
)

export default component.exports